<template>
  <EditableInfoField 
    dense
    :min-height="0"
    :label="$t('Адрес доставки')" 
    :items="items"
    :value="modelAddress"
    prepend-icon="mdi-chevron-left"
    @focus.prevent="e => $store.dispatch('inputFocus', e)"
    kbd-layout="numpad"
    ref="field"
  >
    <template #hint="{ }">
      <v-btn test-tag="tag-90" @click="() => { focus() }" :disabled="!!modelValue.id" icon color="primary" small class="mr-2" style="align-self: start">
        <v-icon>mdi-pen</v-icon>
      </v-btn>
    </template>

    <template #editor="{blurEditable, setEditable}">
      <!-- <vue-tel-input
        :validCharactersOnly="true"
        @focus="e => $store.dispatch('inputFocus', e)"
        v-model="modelAddress"
      /> -->
      <v-form @submit.prevent="blurEditable">
        <InlineSearchField
          :label="$t('Адрес доставки')"
          @focus.stop="e => $store.dispatch('inputFocus', e)"
          @focus.prevent="setEditable"
          @runQuery="suggestAddress"
          @click:item="e => $emit('input', e)"
          :items="search_results"
          append-outer-icon="mdi-check"
          prepend-icon="mdi-chevron-left"
          @click:append-outer="blurEditable"
          @click:prepend="rollbackEdit"
          :messages="[$t('Введите адрес доставки')]"
          v-model="search_query"
        >
          <template #items="{ items, debounce, message }">
            <v-list dense>
              <v-progress-linear color="primary" indeterminate v-if="debounce"></v-progress-linear>
              <div class="mb-2" v-if="search_results === undefined">{{message}}</div>
              <ScrollerHandler style="max-height: calc(40vh - 20px)">
                <v-list-item test-tag="tag-97" :disabled="debounce" v-for="(item, idx) in items" :key="idx" @click="onAddress(item)">
                  <v-list-item-avatar><v-icon>mdi-map-marker-outline</v-icon></v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.value }}</v-list-item-title>
                    <v-list-item-subtitle class="warning--text" v-if="+item.accuracy < 8"><T>Неточный адрес</T></v-list-item-subtitle>
                    <v-list-item-subtitle class="error--text" v-if="+item.coordinates_accuracy > 4"><T>Координаты не определены</T></v-list-item-subtitle>
                    <v-list-item-subtitle class="warning--text" v-else-if="+item.coordinates_accuracy > 1"><T>Неточные координаты</T></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </ScrollerHandler>
            </v-list>
          </template>
        </InlineSearchField>
      </v-form>
    </template>

    <v-menu offset-y>
      <template #activator="{on, attrs}">
        <v-btn test-tag="tag-91" v-on="on" v-bind="attrs" text class="pl-0"> 
          <v-icon v-if="modelValue.id" small class="mr-2">mdi-map-marker-outline</v-icon>
          <v-icon v-else small class="mr-2">mdi-map-marker-question-outline</v-icon>
          {{ modelValue.value }}
          <v-icon>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item test-tag="tag-98" v-for="item in items" :key="item.id" @click="modelValue = item">
          <v-list-item-avatar>
            <v-icon>mdi-map-marker-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.value }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn test-tag="tag-92" icon color="error" small @click.stop="openDialog(item)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item test-tag="tag-99" v-if="lastLocalAddress" @click="modelValue = lastLocalAddress">
          <v-list-item-avatar><v-icon >mdi-map-marker-question-outline</v-icon></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ lastLocalAddress.value }}
            </v-list-item-title>
            <v-list-item-subtitle><T>Добавлен только что</T></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn test-tag="tag-93" @click="rollbackNewPhone" icon color="error" small><v-icon>mdi-trash-can-outline</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item test-tag="tag-100" @click="makeEditable">
          <v-list-item-avatar><v-icon color="primary">mdi-plus</v-icon></v-list-item-avatar>
          <v-list-item-title><T>Добавить адрес доставки</T></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card v-if="selectedItem">
        <v-card-title test-tag="tag-102">
          <T>Удаление адреса доставки</T>
        </v-card-title>

        <v-card-text>
          Это действие приведет к удалению адреса доставки гостя
          "<b>{{ selectedItem.value }}</b>"
          <br />
          Продолжить?
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn test-tag="tag-94" text color="black" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
            <T>Отмена</T>
          </v-btn>

          <v-btn test-tag="tag-95" text color="primary" @click="confirmRemove">
            <v-icon>mdi-check</v-icon>
            <T>Удалить</T>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-card min-height="calc(100vh - 450px)" max-height="300px" class="mt-1"> -->
    <v-card min-height="245px" max-height="400px" height="100%" class="mt-1" :loading="loading" :disabled="loading">
      <div class="d-flex">
        <v-card-text style="flex-shrink: 1.109">
          <h3 class="secondary--text"><T>Зона доставки</T>: <span v-if="deliveryZone">{{ deliveryZone.name }}</span></h3>
          <!-- &lt;Информация о зоне доставки&gt;<br>
          &lt;(втч выбор, если задан неточный адрес)&gt; -->
          <v-list dense v-if="value && value.accuracy < 8">
            <v-banner>
              <v-icon color="error">mdi-comment-alert</v-icon>
              <T>Задан неточный адрес. Дополните адрес при помощи подсказок либо отредактируйте введенный</T>
              <div style="text-align: end;">
                <v-btn test-tag="tag-96" text color="primary" @click.stop="rollbackNewPhone">
                  <T>Ввести заново</T>
                </v-btn>
              </div>
            </v-banner>
            <ScrollerHandler style="max-height: calc(27vh - 20px)">
              <v-list-item test-tag="tag-101" v-for="item, n in search_results.filter(v => v.value != value.value && v.accuracy > 7)" :key="n" @click="()=>{onAddress(item); suggestAddress(item.value)}">
                <v-list-item-avatar><v-icon>mdi-map-marker-outline</v-icon></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.value }}
                  </v-list-item-title>  
                </v-list-item-content>
              </v-list-item>
            </ScrollerHandler>
          </v-list>
        </v-card-text>
        <Map :center="addressCoordinate" :zoom="15" style="max-height: 400px; height: 100%; min-height: 245px; flex-grow: 1.5">
          <LMarker v-if="addressCoordinate" :lat-lng="addressCoordinate" />
          <LPolygon v-if="typeof deliveryZone === 'object'" :lat-lngs="deliveryZone.polygon" />
        </Map>
      </div>
    </v-card>
  </EditableInfoField>
</template>

<script>
import ScrollerHandler from '@/components/scroller_handler'
import InlineSearchField from '@/components/common/InlineSearchField'
import EditableInfoField from '@/components/common/EditableInfoField' 
import Map from '@/components/common/Map'

// import { Fragment } from "vue-fragment";
import { LMarker, LPolygon } from 'vue2-leaflet'

export default {
  props: {
    value: [Object, undefined],
    items: Array,
    default: [Object, undefined],
    deliveryZone: [Object, undefined],
    rules: Array
  },
  data: () => ({
    search_query: '',
    search_results: undefined,
    lastLocalAddress: undefined,
    loading: false,
    valid: true,
    dialog: false,
    selectedItem: null,
  }),
  methods: {
    async getDeliveryZone(coordinates) {
      this.$emit('deliveryZone', await this.$store.dispatch('deliveryZone', coordinates))
    },
    async suggestAddress(addressPart) {
      if ([undefined, null, ''].includes(addressPart)) {
        this.search_results = undefined
      } else {
        this.search_results = await this.$store.dispatch('suggestAddress', addressPart)
      }
    },
    onAddress(item) {
      this.modelValue = item
      this.$store.dispatch('hideKeyboard')
      this.$refs.field.blurEditable()
    },
    makeEditable() {
      // this.modelValue = this.lastLocalAddress ? this.lastLocalAddress.id ? {number: ''} : this.lastLocalAddress : {number: ''}
      this.modelValue = {number: ''}
      this.$refs.field.makeEditable()
      this.focus()
    },
    removeAddress(address) {
      if (this.value?.id == address.id) {
        if (this.lastLocalAddress) {
          this.$emit("input", this.lastLocalAddress)
        } else {
          if (this.default?.id != address.id) {
            this.$emit("input", this.default)
          } else {
            this.$emit("input", this.items.filter(el => el.id != address.id)[0]) // it's ok to emit undefined
          }
        }
      }
      this.$emit('removeAddress', address)
    },
    rollbackEdit() {
      if (!this.lastLocalAddress?.number) {
        this.lastLocalAddress = undefined
        this.$emit('input', this.default ? this.default : this.items[0])
      }
      this.$refs.field.blurEditable()
    },
    rollbackNewPhone(){
      this.lastLocalAddress = undefined
      
      if (!this.value.id) {// current selected phone is the new phone
        this.$emit('input', this.default ? this.default : this.items[0])
      }

      this.$refs.field.blurEditable()
    },
    focus() {
      this.$refs.field.focus()
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.editor.$el.getElementsByTagName('input')[0].focus()
        })
      }, 200)
    },
    async clearAddress(address) {
      return {
        ...address,
        ...(await this.$store.dispatch('suggestAddress', address.value))[0]
      }
    },
    openDialog(item) {
      this.selectedItem = item
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
    },

    confirmRemove() {
      const address = this.selectedItem
      this.closeDialog()

      if (this.value?.id === address.id) {
        if (this.lastLocalAddress) {
          this.$emit("input", this.lastLocalAddress)
        } else if (this.default?.id !== address.id) {
          this.$emit("input", this.default)
        } else {
          this.$emit(
            "input",
            this.items.find(el => el.id !== address.id)
          )
        }
      }

      this.$emit("removeAddress", address)
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      async set(v) {
        this.loading = true
        try {
          if (v.value && !v.coordinates) {
              v = await this.clearAddress(v)
          }

          await this.getDeliveryZone(v.coordinates)

        } finally {
          this.loading = false
        }
        if (!v.id) {
          this.lastLocalAddress = v
        }
        this.$emit('input', v)
      }
    },
    modelAddress: {
      get() {
        return this.modelValue?.value
      },
      set(address) {
        if (address === null) {
          this.lastLocalAddress = { value: '' } 
          this.rollbackEdit()
        } else {
          if (address === '') {
            this.lastLocalAddress = undefined
          } else {
            this.lastLocalAddress = { value: address } 
          }
          this.$emit('input', {...this.modelValue, value: address})
        }       
      }
    },
    addressCoordinate(){
      if(!this.value || !this.value.coordinates){
        return {lat: 55.7558, lng: 37.6173}
      }else{
        return this.value.coordinates
      }
    }
  },
  async mounted() {
    if (!this.modelValue?.id) {
      this.lastLocalAddress = this.modelValue
    }

    this.loading = true
    try {
      if (this.modelValue.value && !this.modelValue.coordinates) {
          this.modelValue = await this.clearAddress(this.modelValue)
      }
      // await this.getDeliveryZone(v.coordinates)

    } finally {
      this.loading = false
    }
  },
  components: {
    InlineSearchField,
    EditableInfoField,
    ScrollerHandler,
    Map,
    LMarker,
    LPolygon
    // Fragment
  },
}
</script>